import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import classNames from "classnames";

import { signOut } from "../../user/actions";
import SlidingComponent from "../components/misc/SlidingComponent";

class RestrictedNavbar extends Component {
  constructor(props) {
    super(props)

    this.state = { accountOpen: false }
  }

  tabClassnames(currentPath) {
    return classNames(
      {"-active": currentPath === this.props.location.pathname},
    );
  }

  accountLiItems = () => {
    return ([
      <li>
        <a id='logout' onClick={this.onLogoutClick} data-testid='navbar-logout'>
          Log out
        </a>
      </li>
    ])
  };

  onLogoutClick = () => {
    this.props.signOut()
    this.props.history.push({ pathname: '/login', search: null })
  }

  setAccountOpen = () => {
    this.setState({ accountOpen: !this.state.accountOpen });
  }

  companyDetails = () => {
    const company = this.props.company;
    if (!company) return;

    return (
      <li>
        <a role="button" onClick={(e) => e.preventDefault()}>{`${company.id} - ${company.company_name}`}</a>
      </li>
    )
  }

  render() {
    return (
      <div className="ds-navigation _desktopOnly">
        <div className="grid --ultraWide">
          <nav className="navigationContent _desktop">
            <ul>
              {this.companyDetails()}
              <li className="account">
                <SlidingComponent
                  checkboxClass="navigationTrigger _desktop"
                  checkboxId="nvTd"
                  labelIconTextOff="arrow_drop_down"
                  labelIconTextOn="arrow_drop_up"
                  labelText={`${this.props.user.first_name} ${this.props.user.last_name}`}
                  liItems={this.accountLiItems()}
                  mobileView={false}
                  open={this.state.accountOpen}
                  setOpen={this.setAccountOpen}
                  dataTestId='account-button'
                />
              </li>
            </ul>
          </nav>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    company: state.company,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  return {
    signOut: () => dispatch(signOut()),
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RestrictedNavbar));



// WEBPACK FOOTER //
// ./src/features/shared/containers/RestrictedNavbar.js